import { Trans } from 'react-i18next'

/**
 * Casilla "He leído y acepto los Términos y la Política de Privacidad", con
 * los dos documentos enlazados. Los enlaces abren en otra pestaña (en la app
 * de iOS, en Safari) para no perder el formulario que se está rellenando.
 */
export default function LegalCheckbox({ docs, checked, onChange, id = 'legal-accept' }) {
  const link = (url) => (
    <a href={url} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()} />
  )
  return (
    <label className="legal-check" htmlFor={id}>
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span>
        <Trans
          i18nKey="legal.accept"
          components={{ terms: link(docs.terms.url), privacy: link(docs.privacy.url) }}
        />
      </span>
    </label>
  )
}
